import { Card, Icon } from "semantic-ui-react";
import useTheme from "../../../../hooks/useTheme";
import AppText from "../../../UI/Texts/AppTexts";
import { SizedBox } from "../../../UI/Sizes";
import { t } from "i18next";
import { parseFormattedText } from "../../../../utils/helperFunctions";
import { AppRow } from "../../../UI/Layouts";

export const CompensationExplanationContent = ({ showIcon = true }) => {
  const theme = useTheme();
  const formattedText = parseFormattedText(
    t("jobdetail.how_much_i_earn.footer"),
    {
      bold: (content) => (
        <AppText.Footnote fontWeight={600}>{content}</AppText.Footnote>
      ),
    },
  );

  return (
    <>
      <AppRow crossAxisAlignment={'center'}>
        {showIcon && (
          <>
            <Icon
              fitted
              circular
              name="info"
              style={{
                color: theme.colors.white,
                fontSize: "0.8rem",
                backgroundColor: theme.primaryColor,
              }}
            />
            <SizedBox width={theme.spacing.elementPaddingSmall} />
          </>
        )}
        <AppText.Caption
          use="h2"
          fontWeight={600}
          margins={{
            marginBottom: "0px",
            marginTop: "0px",
          }}
        >
          {t("jobdetail.how_much_i_earn.title")}
        </AppText.Caption>
      </AppRow>
      <SizedBox height={theme.spacing.elementPaddingSmall} />
      <AppText.Footnote use="strong">
        {t("jobdetail.how_much_i_earn.description")}
      </AppText.Footnote>
      <SizedBox height={theme.spacing.elementPadding} />
      <AppText.Footnote fontWeight={600}>
        {t("jobdetail.how_much_i_earn.list.title")}
      </AppText.Footnote>
      <SizedBox height={theme.spacing.elementPaddingSmall} />
      {[
        "jobdetail.how_much_i_earn.list.item_1",
        "jobdetail.how_much_i_earn.list.item_2",
        "jobdetail.how_much_i_earn.list.item_3",
      ].map((item, index) => (
        <AppText.Footnote
          fontWeight={400}
          margins={{
            marginBottom: "4px",
          }}
          key={index}
        >{`• ${t(item)}`}</AppText.Footnote>
      ))}
      <SizedBox height={"0.8rem"} />
      <AppText.Footnote>{formattedText}</AppText.Footnote>
    </>
  );
};

const ThingsToKnowJob = () => {
  const theme = useTheme();

  return (
    <Card
      fluid
      style={{
        padding: theme.spacing.contentElementPadding,
        borderRadius: theme.radius.default,
        width: "100%",
        marginBottom: theme.spacing.contentElementPadding,
      }}
    >
      <CompensationExplanationContent />
    </Card>
  );
};

export default ThingsToKnowJob;
